export default __webpack_public_path__ + "static/media/accountAggregatorStatus.a02f3c9f.png";